import { memo } from 'react';

import { Button } from '@air/primitive-button';
import { cn } from '@air/utils-tailwind';

export type ItemPickerFooterProps = {
  confirmLabel: string;
  destinationLabel?: string;
  isConfirmDisabled: boolean;
  onCancel: () => void;
  onConfirm: () => void;
};

export const ItemPickerFooter = memo(
  ({ confirmLabel, destinationLabel, isConfirmDisabled, onCancel, onConfirm }: ItemPickerFooterProps) => {
    return (
      <footer
        className={cn(
          'flex shrink-0 items-center ads:border-default border-gray-4 border-t px-6 py-4',
          destinationLabel ? 'justify-between' : 'justify-end',
        )}
      >
        {!!destinationLabel && (
          <div className="flex items-center gap-3" data-testid="ITEM_PICKER_DESTINATION">
            <span className="font-semibold ads:text-metadata text-10 text-gray-10 uppercase">TO</span>
            <span className="font-medium ads:text-primary text-12 text-gray-12">{destinationLabel}</span>
          </div>
        )}
        <div className="flex items-center gap-2">
          <Button
            appearance="ghost"
            color="gray"
            data-testid="ITEM_PICKER_CANCEL"
            onClick={onCancel}
            size="large"
            type="button"
          >
            Cancel
          </Button>
          <Button
            appearance="filled"
            color="blue"
            data-testid="ITEM_PICKER_CONFIRM"
            disabled={isConfirmDisabled}
            onClick={onConfirm}
            size="large"
            type="button"
          >
            {confirmLabel}
          </Button>
        </div>
      </footer>
    );
  },
);

ItemPickerFooter.displayName = 'ItemPickerFooter';
